import { DiagnosticsStackDeviceMainStructure } from '../remote-diagnostics-topology.model';
import { DiagnosticsStackGenericResponse } from '../remote-diagnostics.model';

export const BusTopologyPhaseOne_vitochargeVx3: DiagnosticsStackGenericResponse<
  DiagnosticsStackDeviceMainStructure[]
> = {
  type: 'BusTopologyPhaseOne',
  structure: [
    {
      TI: 'TI_7372956',
      name: 'Master Device',
      structure: [
        {
          RES: ' 62 01 79 37 33 37 32 39 35 36 32 30 31 31 31 36 32 30 36',
          request_parameter_name: 'PA_DataIdent',
          translationid: 'TI_LL_0000_Main_ECU_CAN01',
          service: 'DS_ReadDataByIdent',
          ecu: 'LL_0000_Main_ECU_CAN01',
          requestDate: '2023-04-21T09:54:00.435+0000',
          ecuvariant: 'LL_0000_Main_ECU_CAN01',
          request_parameter_value: 'ViessmannIdentificationNumber',
          securitystatus: 'ECU is unlocked !!!',
          type: 'ECU response structure by parameter name and value',
          structure: [
            {
              semantic: 'SERVICE-ID',
              path: 'PA_ServiID',
              unit: '',
              translationid: '',
              dopname: '',
              name: 'PA_ServiID',
              value: '98',
            },
            {
              semantic: '',
              path: 'PA_DataIdent',
              unit: '',
              translationid: '',
              dopname: '2 Byte Text Table VDD-Greenbook',
              name: 'PA_DataIdent',
              value: 'ViessmannIdentificationNumber',
            },
            {
              semantic: '',
              path: 'PA_DataRecor',
              translationid: '',
              dopname: '2 Byte Table VDD Greenbook',
              name: 'PA_DataRecor',
              structure: [
                {
                  semantic: 'ITEMID',
                  path: 'PA_DataRecor/PA_ItemId',
                  unit: '',
                  translationid: 'TI_ItemId',
                  dopname: '7 Byte Identical ItemId',
                  name: 'PA_ItemId',
                  value: '7372956',
                },
                {
                  semantic: 'PRODUCTIONYEAR',
                  path: 'PA_DataRecor/PA_Year',
                  unit: '',
                  translationid: 'TI_Year',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_Year',
                  value: '2',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_ProceCount',
                  unit: '',
                  translationid: 'TI_ProcessCounter',
                  dopname: '5 Byte Identical ProcessCounter',
                  name: 'PA_ProceCount',
                  value: '01116',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_OverfCountOne',
                  unit: '',
                  translationid: 'TI_OverflowCounterOne',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_OverfCountOne',
                  value: '2',
                },
                {
                  semantic: 'COUNTER',
                  path: 'PA_DataRecor/PA_OverfTwo',
                  unit: '',
                  translationid: 'TI_OverflowTwo',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_OverfTwo',
                  value: '0',
                },
                {
                  semantic: 'VALUE',
                  path: 'PA_DataRecor/PA_Check',
                  unit: '',
                  translationid: 'TI_Checksum',
                  dopname: '1 Byte Identical uint8 ASCII',
                  name: 'PA_Check',
                  value: '6',
                },
              ],
            },
            {
              semantic: '',
              path: 'PA_RecorDataIdentCheck',
              unit: '',
              translationid: '',
              dopname: '',
              name: 'PA_RecorDataIdentCheck',
              value: '',
            },
          ],
          REQ: ' 22 01 79',
        },
        {
          name: 'Main ECU',
          structure: [
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[0]',
              logicallinkname: 'LL_0024_EMCU_CAN01',
              translationid: 'TI_LL_0024_EMCU_CAN01',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5022207_603101',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '1',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_EMCUMaster',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'EMCUMaster',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_Nothing',
                          dopname: '1 Byte TextTable DeviceFunctionEMCU',
                          name: 'PA_Value',
                          value: 'Nothing',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '24',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '502',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2207',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '188',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '24',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '603',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '101',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '1',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7470705',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '00618',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '1',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'Additional ECUs',
          structure: [
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[4]',
              logicallinkname: 'LL_0022_BMCU_CAN57',
              translationid: 'TI_LL_0022_BMCU_CAN57',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5022207_603101',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '57',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_BMCU',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'BMCU',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'ENUMCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_Vitocharge',
                          dopname: '1 Byte TextTable DeviceFunctionBMCU',
                          name: 'PA_Value',
                          value: 'Vitocharge',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '22',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '502',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2207',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '148',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '22',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '603',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '101',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '1',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7470705',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '00618',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '1',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[2]',
              logicallinkname: 'LL_0010_WiFi_CAN58',
              translationid: 'TI_LL_0010_WiFi_CAN58',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixThree',
              variantname: '3102306_0103',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '58',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_BackendGateway',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'BackendGateway',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'ENUM',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_BackeGatew',
                          unit: '',
                          translationid: 'TI_BackendGateway',
                          TI_texttableentry: 'TI_Nothing',
                          dopname: '1 Byte TextTable BackendGateway',
                          name: 'PA_BackeGatew',
                          value: 'Nothing',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '10',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '310',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2306',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '37',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '10',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '3',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7736172',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '0',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '00287',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '8',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[0]',
              logicallinkname: 'LL_0026_CSC_CAN62',
              translationid: 'TI_LL_0026_CSC_CAN62',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixThree',
              variantname: '5002038_600702',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '62',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanRaw',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanRaw',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_CSC',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'CSC',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_Yes',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'Yes',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2038',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '89',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '600',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '702',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '1',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7727520',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '05298',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '0',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '6',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[4]',
              logicallinkname: 'LL_0026_CSC_CAN63',
              translationid: 'TI_LL_0026_CSC_CAN63',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixTwo',
              variantname: '5002038_600702',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '63',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanRaw',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanRaw',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_CSC',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'CSC',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_Yes',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'Yes',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2038',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '89',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '600',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '702',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '1',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7727520',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '03096',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '0',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '0',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[3]',
              logicallinkname: 'LL_0026_CSC_CAN64',
              translationid: 'TI_LL_0026_CSC_CAN64',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixTwo',
              variantname: '5002038_600702',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '64',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanRaw',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanRaw',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_CSC',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'CSC',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_Yes',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'Yes',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2038',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '89',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '600',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '702',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '1',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7727520',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '03094',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '0',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '6',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[2]',
              logicallinkname: 'LL_0026_CSC_CAN65',
              translationid: 'TI_LL_0026_CSC_CAN65',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixTwo',
              variantname: '5002038_600702',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '65',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanRaw',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanRaw',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_CSC',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'CSC',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_Yes',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'Yes',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2038',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '89',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '600',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '702',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '1',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7727520',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '03092',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '0',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '2',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[1]',
              logicallinkname: 'LL_0026_CSC_CAN66',
              translationid: 'TI_LL_0026_CSC_CAN66',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixTwo',
              variantname: '5002038_600702',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '66',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanRaw',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanRaw',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_CSC',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'CSC',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_Yes',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'Yes',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2038',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '89',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '600',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '702',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '1',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7727520',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '03097',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '0',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '7',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[0]',
              logicallinkname: 'LL_0026_CSC_CAN67',
              translationid: 'TI_LL_0026_CSC_CAN67',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixTwo',
              variantname: '5002038_600702',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '67',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanRaw',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanRaw',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_CSC',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'CSC',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_Yes',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'Yes',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2038',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '89',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '26',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '600',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '702',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '1',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7727520',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '03066',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '0',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '3',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[2]',
              logicallinkname: 'LL_0027_EM_CAN97',
              translationid: 'TI_LL_0027_EM_CAN97',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '10201_10000',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '97',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanExternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanExternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_EnergyMeter',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'EnergyMeter',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: '',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Funct',
                          unit: '',
                          translationid: 'TI_Function',
                          TI_texttableentry: 'TI_Source',
                          dopname: '1 Byte TextTable EnergyMeter',
                          name: 'PA_Funct',
                          value: 'Source',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '27',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '102',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '5',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '27',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '100',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '0',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '0102000',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '11401',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '9',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '7',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '0',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[1]',
              logicallinkname: 'LL_0051_HMI_CAN59',
              translationid: 'TI_LL_0051_HMI_CAN59',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrixThree',
              variantname: '5272208_5282207',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '59',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_HMI',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'HMI',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_No',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'No',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '51',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '527',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2208',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '18',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '528',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2207',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '1',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '7470706',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '01612',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '1',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '0',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'Accessories',
          structure: [
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[1]',
              logicallinkname: 'LL_0027_EM_CAN98',
              address: '2',
              translationid: 'TI_LL_0027_EM_CAN98',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '10201_10000',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '98',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanExternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanExternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_EnergyMeter',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'EnergyMeter',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: '',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Funct',
                          unit: '',
                          translationid: 'TI_Function',
                          TI_texttableentry: 'TI_Source',
                          dopname: '1 Byte TextTable EnergyMeter',
                          name: 'PA_Funct',
                          value: 'Source',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '27',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '102',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '1',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '5',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '27',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '100',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '0',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '0',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '0102000',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '11604',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '7',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '8',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '0',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent[3]',
              logicallinkname: 'LL_0100_PGI_CAN96',
              address: '0',
              translationid: 'TI_LL_0100_PGI_CAN96',
              isknownlink: 'true',
              vddname: 'BusTopologyMatrix',
              variantname: '5002310_500259',
              isonlinelink: 'true',
              structure: [
                {
                  semantic: '',
                  path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent',
                  translationid: '',
                  dopname: '36 Byte Structure BusIdentification',
                  name: 'STR_36ByteStrucBusIdent',
                  structure: [
                    {
                      semantic: 'VALUE',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusAddre',
                      unit: '',
                      translationid: 'TI_BusAddress',
                      dopname: '1 Byte Identical uint8 Hex',
                      name: 'PA_BusAddre',
                      value: '96',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_BusType',
                      unit: '',
                      translationid: 'TI_BusType',
                      TI_texttableentry: 'TI_CanInternal',
                      dopname: '1 Byte TextTable BusType',
                      name: 'PA_BusType',
                      value: 'CanInternal',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicObjecPrope',
                      unit: '',
                      translationid: 'TI_DeviceObjectProperty',
                      TI_texttableentry: 'TI_Inverter',
                      dopname: '1 Byte TextTable DeviceObjectProperty',
                      name: 'PA_DevicObjecPrope',
                      value: 'Inverter',
                    },
                    {
                      semantic: 'ENUM',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct',
                      translationid: 'TI_DeviceFunction',
                      dopname: '1 Byte Table DeviceObjectProperty',
                      name: 'PA_DevicFunct',
                      structure: [
                        {
                          semantic: 'BOOLEANCHOICE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_DevicFunct/PA_Value',
                          unit: '',
                          translationid: 'TI_Value',
                          TI_texttableentry: 'TI_Yes',
                          dopname: '1 Byte TextTable NoYes',
                          name: 'PA_Value',
                          value: 'Yes',
                        },
                      ],
                    },
                    {
                      semantic: 'SOFTWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi',
                      translationid: 'TI_SoftwareVersion',
                      dopname: '8 Byte Structure SoftwareVersion',
                      name: 'PA_SoftwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '100',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '2310',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_SoftwVersi/PA_Build',
                          unit: '',
                          translationid: 'TI_Build',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Build',
                          value: '24981',
                        },
                      ],
                    },
                    {
                      semantic: 'HARDWAREVERSION',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi',
                      translationid: 'TI_HardwareVersion',
                      dopname: '8 Byte Structure HardwareVersion',
                      name: 'PA_HardwVersi',
                      structure: [
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Famil',
                          unit: '',
                          translationid: 'TI_Family',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Famil',
                          value: '100',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Versi',
                          unit: '',
                          translationid: 'TI_Version',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Versi',
                          value: '500',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_Revis',
                          unit: '',
                          translationid: 'TI_Revision',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_Revis',
                          value: '259',
                        },
                        {
                          semantic: 'VERSIONVALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_HardwVersi/PA_AssemVaria',
                          unit: '',
                          translationid: 'TI_AssemblyVariant',
                          dopname: '2 Byte Identical uint16',
                          name: 'PA_AssemVaria',
                          value: '1024',
                        },
                      ],
                    },
                    {
                      semantic: 'TARCEABILITY',
                      path: 'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe',
                      translationid: 'TI_ElectronicTraceabilityNumber',
                      dopname: '16 Byte Structure VinModul',
                      name: 'PA_ElectTraceNumbe',
                      structure: [
                        {
                          semantic: 'ITEMID',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ItemId',
                          unit: '',
                          translationid: 'TI_ItemId',
                          dopname: '7 Byte Identical ItemId',
                          name: 'PA_ItemId',
                          value: '0000000',
                        },
                        {
                          semantic: 'PRODUCTIONYEAR',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Year',
                          unit: '',
                          translationid: 'TI_Year',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Year',
                          value: '2',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_ProceCount',
                          unit: '',
                          translationid: 'TI_ProcessCounter',
                          dopname: '5 Byte Identical ProcessCounter',
                          name: 'PA_ProceCount',
                          value: '87454',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfCountOne',
                          unit: '',
                          translationid: 'TI_OverflowCounterOne',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfCountOne',
                          value: '0',
                        },
                        {
                          semantic: 'COUNTER',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_OverfTwo',
                          unit: '',
                          translationid: 'TI_OverflowTwo',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_OverfTwo',
                          value: '2',
                        },
                        {
                          semantic: 'VALUE',
                          path:
                            'PA_DataRecor/PA_Devic/STR_36ByteStrucBusIdent/PA_ElectTraceNumbe/PA_Check',
                          unit: '',
                          translationid: 'TI_Checksum',
                          dopname: '1 Byte Identical uint8 ASCII',
                          name: 'PA_Check',
                          value: '0',
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: 'OfflineECUs',
          structure: [
            {
              logicallinkname: 'LL_0018_HMI_CAN59',
              translationid: 'TI_LL_0018_HMI_CAN59',
              isknownlink: 'true',
              isonlinelink: 'false',
            },
            {
              logicallinkname: 'LL_0039_PGI_CAN96',
              translationid: 'TI_LL_0039_PGI_CAN96',
              isknownlink: 'true',
              isonlinelink: 'false',
            },
            {
              logicallinkname: 'LL_0026_CSC_CAN60',
              translationid: 'TI_LL_0026_CSC_CAN60',
              isknownlink: 'true',
              isonlinelink: 'false',
            },
            {
              logicallinkname: 'LL_0026_CSC_CAN61',
              translationid: 'TI_LL_0026_CSC_CAN61',
              isknownlink: 'true',
              isonlinelink: 'false',
            },
          ],
        },
        {
          request_parameter_name: 'PA_ItemNumbe',
          translationid: 'TI_LL_0000_Main_ECU_CAN01',
          service: 'DS_ProduDefin',
          ecu: 'LL_0000_Main_ECU_CAN01',
          bundleID: 'B_00079_VCH200',
          request_parameter_value: '7372956',
          type: 'RequestStructureByParameterNameAndValue',
        },
      ],
    },
  ],
};
